import React from 'react';
import { createRoot } from 'react-dom/client';
import AuthGate from './components/AuthGate';
import { installAuthFetch } from './utils/authFetch';
import { installTheme } from './utils/theme';
import './styles/main.css'; // Adjust path if needed
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';

// before anything renders, so the first project fetch already carries the token
installAuthFetch();
// before render, so the page never paints one theme and then swaps
installTheme();

const container = document.getElementById('root');
const root = createRoot(container);
// The gate shows the public landing page until there is a live session, and the
// dashboard only after one — see AuthGate.
root.render(<AuthGate />);
